// /Users/xingyunx/workplace/workspace/RingcentralAnalysisPortal/src/composables/useTeamDialog.ts
// Composable for managing team dialog state globally
// Provides a way to open the team-add dialog from anywhere in the app
// RELEVANT FILES: src/components/app-sidebar/team-switcher.vue, src/components/dashboard/DashboardOnboarding.vue

import { ref } from 'vue';

// Global state for the team dialog
const isTeamDialogOpen = ref(false);
const dialogMode = ref<'add' | 'manage'>('add');
const selectedOrganizationId = ref<string | null>(null);

export function useTeamDialog() {
  function openAddTeamDialog() {
    dialogMode.value = 'add';
    selectedOrganizationId.value = null;
    isTeamDialogOpen.value = true;
  }

  function openManageTeamDialog(organizationId: string) {
    dialogMode.value = 'manage';
    selectedOrganizationId.value = organizationId;
    isTeamDialogOpen.value = true;
  }

  function closeTeamDialog() {
    isTeamDialogOpen.value = false;
    selectedOrganizationId.value = null;
  }

  return {
    isTeamDialogOpen,
    dialogMode,
    selectedOrganizationId,
    openAddTeamDialog,
    openManageTeamDialog,
    closeTeamDialog,
  };
}
